import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import api from "../axiosConfig";
import ModalComp from "../themes/Model";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  createTheme,
  FormControl,
  FormHelperText,
  Grid,
  Snackbar,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { getUser } from "../helpers";
import { useModalContext } from "../ModalContext";
import { LoadingButton } from "@mui/lab";
import LoadingSpinner from "./LoadingSpinner";

function AddNewForecasting({
  data,
  setCustomOpenModal,
  shouldDisableDate,
  priceListUpdateButton,
  isModalOpen,
  setIsModalOpen,
  addRowDataForecastingProduct,
}) {
  const user = getUser();
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [productNames, setProductNames] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [priceLists, setPriceLists] = useState([]);
  const [selectedPriceList, setSelectedPriceList] = useState("");
  const [selectedPriceListValue, setSelectedPriceListValue] = useState("");
  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState("");
  const [mrp, setMrp] = useState("");
  const [ptr, setPtr] = useState("");
  const [selectedProductCode, setSelectedProductCode] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMrpTax, setLoadingMrpTax] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalFormData, setModalFormData] = useState({
    warehouse: "",
    channel: "",
    priceList: "",
    product: "",
    StartDate: null,
    EndDate: null,
    qty: "",
  });
  const [errors, setErrors] = useState({});
  const searchParams = new URLSearchParams();
  const monthYear = dayjs(searchParams.get("monthYear"));

  // global state
  const { currency } = useModalContext();

  // dropdown api's
  useEffect(() => {
    api
      .get("/warehouses")
      .then((response) => setWarehouses(response.data || []))
      .catch((error) => console.error("Error fetching warehouses:", error));

    api
      .get("/channels")
      .then((response) => setChannels(response.data || []))
      .catch((error) => console.error("Error fetching channels:", error));

    // api
    //   .get("/pricelist")
    //   .then((response) => setPriceLists(response.data || []))
    //   .catch((error) => console.error("Error fetching categories:", error));

    api
      .get("/productswithname")
      .then((response) => setProductNames(response.data || []))
      .catch((error) => console.error("Error fetching productNames:", error));
  }, []);

  // Fetch filtered PriceList when selectedChannel changes
  useEffect(() => {
    if (selectedChannel) {
      api
        .post("/pricelist", { channel: selectedChannel })
        .then((response) => {
          setPriceLists(response.data || []);
        })
        .catch((error) => console.error("Error fetching pricelists:", error));
    } else {
      setPriceLists([]); // Clear priceList dropdown if no channel is selected
    }
  }, [selectedChannel]); // Trigger when selectedChannel changes

  // Dropdown handler's
  const handleWarehouseChange02 = (event, newWarehouseValue) => {
    const selectedWarehouse = warehouses.find(
      (warehouse) => warehouse.Warehouse === newWarehouseValue
    );

    setSelectedWarehouse(selectedWarehouse ? selectedWarehouse.Warehouse : "");
    setModalFormData((prevData) => ({
      ...prevData,
      warehouse: selectedWarehouse ? selectedWarehouse.Warehouse : "",
    }));

    if (newWarehouseValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        warehouse: "",
      }));
    }
  };

  // Handle Channel Selection
  const handleChannelChange = (event, newValue) => {
    const selectedChannelObj = channels.find(
      (channel) => channel.Channel === newValue
    );

    const selectedChannelValue = selectedChannelObj
      ? selectedChannelObj.Channel
      : "";
    setSelectedChannel(selectedChannelValue);

    // Reset PriceList when channel changes
    setSelectedPriceList(null);
    setSelectedPriceListValue("");

    setModalFormData((prevData) => ({
      ...prevData,
      channel: selectedChannelValue,
      priceList: "",
    }));

    if (newValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        channel: "",
        priceList: "",
      }));
    }
  };

  const handlePriceListChange = (event, newValue) => {
    setSelectedPriceList(newValue);
    setSelectedPriceListValue(newValue ? newValue.Pricelist : "");

    setModalFormData((prevData) => ({
      ...prevData,
      priceList: newValue ? newValue.PriceList : "",
    }));

    if (newValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        priceList: "",
      }));
    }
  };
  const handleProductChange = (event, newValue) => {
    if (!newValue) return;
    //console.log("newValue",newValue)
    setModalFormData((prevData) => ({
      ...prevData,
      product: newValue.Product_Name,
      productCode: newValue.ProductCode,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      product: "",
    }));
     setSelectedProduct(newValue.Product_Name); 
  };

  //date picker disable function
  const disableDateCondition = (date) => {
    const today = dayjs().startOf("day");
    const tomorrow = today.add(1, "day");
    const startDate = modalFormData.StartDate
      ? dayjs(modalFormData.StartDate)
      : dayjs().startOf("day");
    return (
      date.isSame(today, "day") ||
      date.isSame(tomorrow, "day") ||
      date.isBefore(startDate, "day")
    );
  };

  // Call API when all dropdowns are selected
  useEffect(() => {
    if (
      selectedWarehouse &&
      selectedChannel &&
      selectedPriceList &&
      selectedProduct &&
      modalFormData.StartDate &&
      modalFormData.EndDate
    ) {
      updateMrpPtr();
    }
  }, [
    selectedWarehouse,
    selectedChannel,
    selectedPriceList,
    selectedProduct,
    modalFormData.StartDate,
    modalFormData.EndDate,
  ]);

  const updateMrpPtr = () => {
    setLoadingMrpTax(true);
    const apiEndpoint = "/api/getmrpptr";

    api
      .post(apiEndpoint, {
        body: {
          Warehouse: modalFormData?.warehouse,
          Channel: modalFormData?.channel,
          Pricelist: selectedPriceListValue,
          ProductCode: modalFormData?.productCode,
          StartDate: modalFormData?.StartDate || "",
          EndDate: modalFormData?.EndDate || "",
        },
      })
      .then((response) => {
        console.log("API Response:", response.data);

        // Check if response data is an array and has at least one item
        if (Array.isArray(response.data) && response.data.length > 0) {
          const firstItem = response.data[0]; // Extract the first object

          // Update MRP and PTR states
          setMrp(firstItem.MRP);
          setPtr(firstItem.PTR);

          // Success message
          setSnackbarMessage("MRP/PTR data updated successfully.");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        } else {
          // ⚠️ Warning if no data is found
          console.warn(
            "No MRP/PTR data found for this selection:",
            response.data
          );

          setMrp("");
          setPtr("");

          setSnackbarMessage(
            "No MRP/PTR data found for this combination. Please contact support."
          );
          setSnackbarSeverity("warning");
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        console.error("Error updating MRP/PTR:", error);
        setSnackbarMessage(
          "MRP/PTR data could not be updated. Please try again later."
        );
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      })
      .finally(() => {
        setLoadingMrpTax(false);
      });
  };

  //[alert handler]
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  //set validation
  const validateForm = () => {
    const newErrors = {};
    if (modalFormData.warehouse?.length === 0)
      newErrors.warehouse = "Warehouse is required";
    if (modalFormData.product?.length === 0)
      newErrors.product = "Product is required";
    if (modalFormData.priceList?.length === 0)
      newErrors.priceList = "PriceList is required";
    if (modalFormData.channel?.length === 0)
      newErrors.channel = "channel is required";
    if (!modalFormData.StartDate)
      newErrors.StartDate = "Start date is required";
    if (!modalFormData.EndDate) newErrors.EndDate = "End date is required";
    if (modalFormData.StartDate && modalFormData.EndDate) {
      const start = dayjs(modalFormData.StartDate);
      const end = dayjs(modalFormData.EndDate);
      if (end.isBefore(start))
        newErrors.EndDate = "End date cannot be before start date";
    }
    if (!mrp) newErrors.mrp = "MRP is required";
    else if (isNaN(mrp)) newErrors.mrp = "MRP must be a number";

    if (!ptr) newErrors.ptr = "PTR is required";
    else if (isNaN(ptr)) newErrors.ptr = "PTR must be a number";

    if (!modalFormData.qty) newErrors.qty = "Quantity is required";
    else if (isNaN(modalFormData.qty))
      newErrors.qty = "Quantity must be a number";

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  //reset Modal data
  const ResetForms = () => {
    setModalFormData({
      warehouse: "",
      product: "",
      channel: "",
      priceList: "",
      StartDate: "",
      EndDate: "",
      mrp: "",
      ptr: "",
      qty: "",
    });

    // Reset other related states
    setSelectedWarehouse("");
    setSelectedProduct("");
    setSelectedChannel("");
    setSelectedPriceList("");
    setMrp("");
    setPtr("");

    // Clear errors
    setErrors({});
  };

  //submit Modal data handler
  const handleSubmit = () => {
    setLoading(true);
    if (validateForm()) {
      const apiEndpoint = "/api/addnewproductforecasting ";
      const requestBody = {
        Warehouse: modalFormData.warehouse,
        Channel: modalFormData.channel,
        Pricelist: selectedPriceListValue,
        ProductCode: modalFormData.productCode,
        StartDate: modalFormData.StartDate,
        EndDate: modalFormData.EndDate,
        MRP: mrp,
        PTR: ptr,
        Quantity_Per_Day: modalFormData.qty,
        user,
        currencyType: currency,
        page: "pricelist",
      };
      api
        .post(apiEndpoint, { body: requestBody })
        .then((response) => {
          console.log("API Response:", response.data);

          if (
            response.data?.status === "fail" &&
            response.data?.Message.includes("Already Product is available")
          ) {
            // ⚠️ Product already exists - show warning message
            setSnackbarMessage(
              "This product is already added. You cannot add it again."
            );
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
            setLoading(false);
          } else {
            // ✅ Success - reset form and show success message
            addRowDataForecastingProduct(response.data.data_updated);
            console.log(
              response.data.data_updated,
              "response.data.data_updated"
            );
            ResetForms();
            handleClose();
            setSnackbarMessage("ForeCasting Product successfully added.");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error saving product:", error);
          setSnackbarMessage(
            "ForeCasting Product could not be added. Please try again later or contact support if the issue persists."
          );
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  //disable button

  const isFormComplete =
    mrp &&
    ptr &&
    selectedWarehouse.length > 0 &&
    selectedProduct.length > 0 &&
    selectedPriceList &&
    selectedPriceListValue &&
    selectedChannel &&
    modalFormData.StartDate &&
    modalFormData.EndDate &&
    modalFormData.qty;

  // date picker style

  const customTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontSize: "14px", // Font size for the input field
            },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for the calendar days
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for typography inside the Date Picker
          },
        },
      },
    },
  });

  // modak content
  const modalContent = (
    <>
      <div className="forecasting-content-wrapper">
        <Box
          sx={{
            bgcolor: "background.paper",
            maxWidth: 800,
            maxHeight: "80vh",
            overflowY: "auto",
            mx: "auto",
          }}
        >
          <Grid container spacing={2}>
            {/* warehouse & channel */}
            <Grid
              item
              //   xs={6}
              sx={{
                display: "flex",
                gap: "20px",
                marginTop: "5px",
                width: "100%",
              }}
            >
              <FormControl
                xs={6}
                style={{ width: "100%", flexGrow: 1 }}
                error={!!errors.warehouse}
              >
                <Autocomplete
                  options={warehouses.map(({ Warehouse }) => Warehouse)}
                  value={selectedWarehouse}
                  onChange={handleWarehouseChange02}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Warehouse"
                      variant="outlined"
                      fullWidth
                      error={!!errors.warehouse}
                    />
                  )}
                  sx={{ width: "100%" }}
                  error={Boolean(errors.warehouse)}
                  size="small"
                />
                {errors.warehouse && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000 !important",
                      marginTop: "4px !important",
                      marginLeft: "0",
                      marginRight: "0",
                    }}
                  >
                    {errors.warehouse}*
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl
                xs={6}
                style={{ width: "100%", flexGrow: 1 }}
                error={!!errors.channel}
              >
                <Autocomplete
                  options={channels.map(({ Channel }) => Channel)}
                  value={selectedChannel}
                  onChange={handleChannelChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Channel"
                      variant="outlined"
                      fullWidth
                      error={!!errors.channel}
                      size="small"
                    />
                  )}
                  sx={{ width: "100%" }}
                  error={Boolean(errors.channel)}
                />
                {errors.channel && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000 !important",
                      marginTop: "4px !important",
                      marginLeft: "0",
                      marginRight: "0",
                    }}
                  >
                    {errors.channel}*
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            {/* product and price-list */}
            <Grid
              item
              sx={{
                display: "flex",
                gap: "20px",
                width: "100%",
              }}
            >
              <FormControl fullWidth error={!!errors.product}>
                <Autocomplete
                  options={productNames}
                  getOptionLabel={(option) =>
                    option ? `${option.Product_Name} (${option.ProductCode})` : ""
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.ProductCode === value.ProductCode
                  }
                  value={productNames.find(
                    (p) => p.ProductCode === modalFormData.productCode
                  ) || null}
                  onChange={handleProductChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Product"
                      variant="outlined"
                      fullWidth
                      size="small"
                      error={!!errors.product}
                    />
                  )}
                  sx={{ width: "100%" }}
                />
                {errors.product && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000 !important",
                      marginTop: "4px !important",
                      marginLeft: "0",
                      marginRight: "0",
                    }}
                  >
                    {errors.product}*
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl
                style={{ width: "100%", flexGrow: 1 }}
                error={!!errors.priceList}
              >
                <Autocomplete
                  options={priceLists}
                  getOptionLabel={(option) => option.Pricelist || ""}
                  value={selectedPriceList}
                  onChange={handlePriceListChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="PriceList"
                      variant="outlined"
                      fullWidth
                      error={!!errors.priceList}
                      size="small"
                    />
                  )}
                  sx={{ width: "100%" }}
                />
                {errors.priceList && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000 !important",
                      marginTop: "4px !important",
                      marginLeft: "0",
                      marginRight: "0",
                    }}
                  >
                    {errors.priceList}*
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            {/* date */}
            <ThemeProvider theme={customTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  className="forecasting-date-picker"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "20px",
                    marginTop: "20px",
                    // marginBottom: "15px",
                    marginLeft: "16px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="Start Date"
                      sx={{ width: "100%" }}
                      value={
                        modalFormData.StartDate
                          ? dayjs(modalFormData.StartDate)
                          : null
                      }
                      defaultCalendarMonth={dayjs(monthYear)}
                      // value={
                      //   modalFormData.StartDate
                      //     ? dayjs(modalFormData.StartDate)
                      //     : !isNaN(Number(selectedDate))
                      //     ? dayjs(
                      //         new Date(
                      //           monthYear.year(),
                      //           monthYear.month(),
                      //           selectedDate
                      //         )
                      //       )
                      //     : null
                      // }
                      onChange={(newValue) => {
                        setModalFormData((prevData) => ({
                          ...prevData,
                          StartDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            StartDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          margin="normal"
                          error={Boolean(errors.StartDate)}
                        />
                      )}
                      disablePast={true}
                      minDate={monthYear.startOf("month")}
                      maxDate={monthYear.endOf("month")}
                      shouldDisableDate={(date) => {
                        const dayjsDate = dayjs(date); // Convert to Day.js instance
                        // const startOfMonth = monthYear.startOf("month");
                        // const endOfMonth = monthYear.endOf("month");
                        const today = dayjs().startOf("day");
                        const tomorrow = today.add(1, "day");
                        const endDate = modalFormData.EndDate
                          ? dayjs(modalFormData.EndDate)
                          : null;

                        return (
                          dayjsDate.isBefore(
                            monthYear.startOf("month"),
                            "day"
                          ) ||
                          dayjsDate.isAfter(monthYear.endOf("month"), "day") ||
                          dayjsDate.isSame(today, "day") ||
                          dayjsDate.isSame(tomorrow, "day") ||
                          // dayjsDate.isBefore(startOfMonth, "day") ||
                          // dayjsDate.isAfter(endOfMonth, "day") ||
                          (endDate && dayjsDate.isAfter(endDate, "day"))
                        );
                      }}
                      openTo="day" // Ensure it opens to the day view
                      // defaultCalendarMonth={monthYear}
                      // disabled={isNaN(Number(selectedDate)) === false}
                    />
                    {errors.StartDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.StartDate}*
                      </FormHelperText>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="End Date"
                      sx={{ width: "100%" }}
                      value={
                        modalFormData.EndDate
                          ? dayjs(modalFormData.EndDate)
                          : null
                      }
                      // value={
                      //   modalFormData.StartDate
                      //     ? dayjs(modalFormData.StartDate)
                      //     : !isNaN(Number(selectedDate))
                      //     ? dayjs(
                      //         new Date(
                      //           monthYear.year(),
                      //           monthYear.month(),
                      //           selectedDate
                      //         )
                      //       )
                      //     : null
                      // }
                      onChange={(newValue) => {
                        setModalFormData((prevData) => ({
                          ...prevData,
                          EndDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            EndDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth margin="normal" />
                      )}
                      disablePast={true}
                      minDate={monthYear.startOf("month")} // Start of the selected month
                      maxDate={monthYear.endOf("month")}
                      shouldDisableDate={(date) => {
                        const dayjsDate = dayjs(date); // Convert to Day.js instance
                        const today = dayjs().startOf("day");
                        const tomorrow = today.add(1, "day");
                        const startDate = modalFormData.StartDate
                          ? dayjs(modalFormData.StartDate)
                          : dayjs().startOf("day");
                        const startOfMonth = monthYear.startOf("month");
                        const endOfMonth = monthYear.endOf("month");

                        return (
                          dayjsDate.isBefore(
                            monthYear.startOf("month"),
                            "day"
                          ) ||
                          dayjsDate.isAfter(monthYear.endOf("month"), "day") ||
                          dayjsDate.isSame(today, "day") ||
                          dayjsDate.isSame(tomorrow, "day") ||
                          // dayjsDate.isBefore(startOfMonth, "day") ||
                          // dayjsDate.isAfter(endOfMonth, "day") ||
                          dayjsDate.isBefore(startDate, "day")
                        );
                      }}
                      openTo="day" // Ensure it opens to the day view
                      defaultCalendarMonth={monthYear}
                      // disabled={isNaN(Number(selectedDate)) === false}
                    />
                    {errors.EndDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.EndDate}*
                      </FormHelperText>
                    )}
                  </Box>
                </Box>
              </LocalizationProvider>
            </ThemeProvider>

            {/* MRP & PTR*/}
            <Grid item xs={12} sx={{ display: "flex", gap: "20px" }}>
              <Grid item xs={6} sx={{ width: "100%" }}>
                <TextField
                  disabled
                  fullWidth
                  sx={{ width: "100%" }}
                  label="MRP"
                  name="MRP"
                  value={mrp}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalFormData((prevData) => ({
                      ...prevData,
                      mrp: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        mrp: "",
                      }));
                    }
                  }}
                  error={Boolean(errors.mrp)}
                  size="small"
                />
                {errors.mrp && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.mrp}*
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6} sx={{ width: "100%" }}>
                <TextField
                  disabled
                  fullWidth
                  sx={{ width: "100%" }}
                  label="PTR"
                  name="PTR"
                  value={ptr}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalFormData((prevData) => ({
                      ...prevData,
                      ptr: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        ptr: "",
                      }));
                    }
                  }}
                  error={Boolean(errors.ptr)}
                  size="small"
                />
                {errors.ptr && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.ptr}*
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
            {/* QTY */}
            <Grid
              item
              xs={6}
              sx={{ display: "flex", gap: "20px", width: "100%" }}
            >
              <Grid
                //  item
                sx={{ width: "100%" }}
              >
                <TextField
                  fullWidth
                  sx={{ width: "100%" }}
                  label="Qty Per Day"
                  name="Qty Per Day"
                  value={modalFormData.qty}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalFormData((prevData) => ({
                      ...prevData,
                      qty: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        qty: "",
                      }));
                    }
                  }}
                  error={Boolean(errors.qty)}
                  size="small"
                />
                {errors.qty && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.qty}*
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );

  // modal buttons
  const actionButtons = (
    <>
      <LoadingButton
        variant="contained"
        color="primary"
        onClick={() => {
          handleSubmit();
        }}
        loading={loading}
        loadingPosition="end"
        disabled={!isFormComplete}
        style={{
          fontSize: "12px",
          backgroundColor: isFormComplete ? "#16a695" : "#16a69590",
          color: "white",
          marginRight: "8px",
          opacity: isFormComplete ? 1 : 0.5,
          cursor: isFormComplete ? "pointer" : "not-allowed",
          paddingRight: loading ? "35px" : "",
        }}
        size="small"
      >
        {loading ? "Updating..." : "Update New Product"}
      </LoadingButton>

      <Button
        variant="outlined"
        onClick={() => {
          handleClose();
          ResetForms();
        }}
        style={{ fontSize: "12px", color: "#000", borderColor: "#707070" }}
        size="small"
      >
        Cancel
      </Button>
    </>
  );

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <ModalComp
        open={isModalOpen}
        setCustomOpenModal={setCustomOpenModal}
        handleClose={handleClose}
        title={
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            Add New Forecasting Product
            {loadingMrpTax && 
            <LoadingSpinner 
            color="#17A591"
            width = {"25px !important"}
            height={"25px !important"}
            />}
          </span>
        }
        
        modalContent={modalContent}
        modelButtons={actionButtons}
        datePickerStyle={{ width: "48%", margin: "5px" }}
        themeStyles={{
          boxStyle: {
            width: "682px",
            height: "auto",
            margin: "auto",
            marginTop: "80px",
          },
          titleStyle: {
            fontSize: "18px",
            fontWeight: 600,
            color: "#000",
            backgroundColor: "#F4F4F4",
            padding: "24px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          fieldStyle: { width: "100%", marginTop: "20px" },
          actionButtonContainerStyle: {
            padding: "0 20px 20px 20px",
          },
        }}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default AddNewForecasting;
